import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {List, Record, Map} from 'immutable';
import DepartmentActions from 'actions/department/DepartmentActions';
import DepartmentFormActions from 'actions/DepartmentFormActions';
import ToastStore from '@store/toast/ToastStore';
import {browserHistory} from 'react-router';
import Department, {DepartmentId} from 'records/Department';
import {Store} from '@store/@types/alt';
import {associateBy} from 'utils/associateBy';

class DepartmentStoreState extends Record({
  selectedDepartment: null,
  departmentProfiles: List(),
  departmentMap: Map(),
  wasDepartmentProfilesFetchError: false,
  areDepartmentProfilesLoading: false,
  areDepartmentProfilesLoaded: false,
  // the department of the current user
  department: null,
}) {
  selectedDepartment: Department | null;
  departmentProfiles: List<Department>;
  departmentMap: Map<DepartmentId, Department>;
  wasDepartmentProfilesFetchError: boolean;
  areDepartmentProfilesLoading: boolean;
  areDepartmentProfilesLoaded: boolean;
  // the department of the current user
  department: Department | null;
}

@immutableStore
class DepartmentStore extends Store<DepartmentStoreState> {
  constructor() {
    super();
    this.state = new DepartmentStoreState();
    this.bindActions(DepartmentActions);
    this.bindActions(DepartmentFormActions);

    // new exciting horrors
    this.exportPublicMethods({addDepartment: this.addDepartment.bind(this)});
  }

  onUpdateSelectedDepartment(selectedDepartment) {
    this.setState({selectedDepartment});
  }

  onFetchDepartmentProfiles() {
    this.setState({
      areDepartmentProfilesLoading: true,
      areDepartmentProfilesLoaded: false,
      departmentProfiles: List(),
    });
  }

  onFetchDepartmentProfilesSuccess(departmentProfiles) {
    this.setState({
      areDepartmentProfilesLoading: false,
      wasDepartmentProfilesFetchError: false,
      areDepartmentProfilesLoaded: true,
      departmentProfiles,
      departmentMap: associateBy(departmentProfiles, d => d.id),
    });
  }

  onFetchDepartmentProfilesError() {
    this.setState({
      areDepartmentProfilesLoading: false,
      wasDepartmentProfilesFetchError: true,
      areDepartmentProfilesLoaded: false,
    });
  }

  onFetchUserDepartmentSuccess(department) {
    this.setState({
      department,
    });
  }

  onFetchUserDepartmentError(error) {
    console.error('onFetchUserDepartmentError', error);
  }

  onUpdateDepartmentSuccess(updatedDepartment) {
    const {departmentProfiles} = this.state;
    const index = departmentProfiles.findKey(({id}) => id === updatedDepartment.id);
    this.setState({
      departmentProfiles: this.state.departmentProfiles.set(index, updatedDepartment),
    });
    ToastStore.addToast({
      type: 'success',
      time: 2000,
      message: 'Department updated!',
    });
  }

  onUpdateDepartmentError() {
    ToastStore.addToast({
      type: 'error',
      message: 'There was a problem communicating with the server when saving the department.',
    });
  }

  addDepartment(createdDepartment) {
    this.setState({
      departmentProfiles: this.state.departmentProfiles.push(createdDepartment),
    });
  }

  deleteDepartmentSuccess() {
    browserHistory.goBack();
    ToastStore.addToast({
      type: 'success',
      time: 2000,
      message: 'Department deleted!',
    });
  }

  deleteDepartmentError(error) {
    ToastStore.addToast({
      type: 'error',
      message: 'There was a problem deleting the department.',
    });
  }
}

export default alt.createStore(DepartmentStore);
